<div class="reporting-list">
  <ts-page-header>
    <ng-container page-header-title>
      <ts-breadcrumb [items]="[{ label: 'Report Builder', routerLink: ['/reporting/list'] }]"></ts-breadcrumb>
    </ng-container>
    <ng-container page-header-action-buttons>
      <ts-button
        [appAuthorize]="NewPermission.REPORT_BUILDER_CREATE"
        denyAction="disable"
        variant="primary"
        icon="add"
        (click)="create()"
        >New Report
      </ts-button>
    </ng-container>
    <ng-container page-header-action-bar>
      <div class="search">
        <ts-input icon="ts_search" placeholder="Search" [formControl]="searchInputControl"></ts-input>
      </div>
    </ng-container>
  </ts-page-header>
  <div class="reporting-list__middle" [ngClass]="{ 'overlay-blur': !!(loadingReportLayouts | async) }">
    <mat-progress-bar
      class="absolute z-10"
      *ngIf="loadingReportLayouts | async"
      mode="indeterminate"
    ></mat-progress-bar>
    <ng-container *ngIf="customObjects$ | async as customObjects">
      <ng-container *ngIf="layoutsPage$ | async as layoutsPage">
        <div class="reporting-list__middle__table-wrapper">
          <ng-container *ngIf="layoutsPage.results.length > 0; else noData">
            <div class="old-ts-table-container">
              <table
                aria-labelledby="layouts table"
                mat-table
                [dataSource]="layoutsPage.results"
                class="table-container"
              >
                <ng-container matColumnDef="fav">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let row" class="text-center">
                    <mat-icon *ngIf="!row.is_favorite" (click)="toggleFavorite(row.id)">star_border</mat-icon>
                    <mat-icon *ngIf="row.is_favorite" class="favorite" (click)="toggleFavorite(row.id)">star</mat-icon>
                  </td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Name</th>
                  <td mat-cell *matCellDef="let row" [routerLink]="['../builder', row.id]">
                    <a>{{ row.name }}</a>
                    <p class="description">{{ row.description }}</p>
                  </td>
                </ng-container>
                <ng-container matColumnDef="relatedTo">
                  <th mat-header-cell *matHeaderCellDef>Type</th>
                  <td mat-cell *matCellDef="let row">
                    {{ getRelatedTo(row.definition, customObjects) }}
                    {{ row.report_type === 'time_series' ? '(Time Series)' : null }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="user_id">
                  <th mat-header-cell *matHeaderCellDef>Created by</th>
                  <td mat-cell *matCellDef="let row" [routerLink]="['../builder', row.id]">
                    <div class="ts-cell-with-avatar">
                      <img src="{{ row?.user?.avatar_url }}" alt="" />
                      {{ row?.user?.name }}
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="created_at">
                  <th mat-header-cell *matHeaderCellDef>Created date</th>
                  <td mat-cell *matCellDef="let row" [routerLink]="['../builder', row.id]">
                    {{ row.created_at | date: 'LLL dd, y' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let row" class="text-right">
                    <mat-menu #menu="matMenu">
                      <button
                        mat-menu-item
                        [routerLink]="['../builder', row.id]"
                        [appAuthorize]="row?.permissions?.is_viewable"
                      >
                        <ts-icon icon="ts_eye" iconColor="black"></ts-icon>
                        View
                      </button>
                      <button
                        [appAuthorize]="row?.permissions?.is_editable"
                        denyAction="hide"
                        mat-menu-item
                        [routerLink]="['../builder', row.id]"
                      >
                        <ts-icon icon="edit" iconColor="black"></ts-icon>
                        Edit
                      </button>
                      <button
                        [appAuthorize]="NewPermission.REPORT_BUILDER_CREATE"
                        denyAction="hide"
                        mat-menu-item
                        (click)="duplicate(row)"
                      >
                        <ts-icon icon="ts_copy" iconColor="black"></ts-icon>
                        Duplicate
                      </button>
                      <button
                        [appAuthorize]="row?.permissions?.is_deletable"
                        denyAction="hide"
                        class="red-delete"
                        mat-menu-item
                        (click)="delete(row)"
                      >
                        <ts-icon icon="ts_trash-alt" color="red"></ts-icon>
                        Delete
                      </button>
                    </mat-menu>
                    <ts-button
                      [debounceTime]="0"
                      type="icon"
                      icon="more_horiz"
                      color="accent"
                      [matMenuTriggerFor]="menu"
                    ></ts-button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns" class="row dashboard-row"></tr>
              </table>
            </div>
          </ng-container>
        </div>

        <ts-paginator
          [totalItems]="layoutsPage.count"
          [pageSize]="layoutsPage.per_page"
          [activePage]="layoutsPage.page"
          (pageChanged)="onPageChange($event)"
        ></ts-paginator>
      </ng-container>

      <ng-template #noData>
        <div class="reporting-list__no-data">No results</div>
      </ng-template>
    </ng-container>
  </div>
</div>
